export default __webpack_public_path__ + "static/media/HV-808.8ddc39b5.png";